/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Notreviewingcoinvestments5Inputs */

const en_coinvestments_declinedeal_reasons_notreviewingcoinvestments5 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Notreviewingcoinvestments5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not reviewing co-investments currently`)
};

/**
* | output |
* | --- |
* | "Not reviewing co-investments currently" |
*
* @param {Coinvestments_Declinedeal_Reasons_Notreviewingcoinvestments5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_notreviewingcoinvestments5 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Notreviewingcoinvestments5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Notreviewingcoinvestments5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_notreviewingcoinvestments5(inputs)
});
export { coinvestments_declinedeal_reasons_notreviewingcoinvestments5 as "coInvestments_declineDeal_reasons_notReviewingCoInvestments" }